// extracted by mini-css-extract-plugin
export var endTheFun = "Welcome_endTheFun__h21pJ";
export var shoppingCreditActiveSubscriptionContainer = "Welcome_shoppingCreditActiveSubscriptionContainer__lK7uY";
export var subtitle = "Welcome_subtitle__tQ5U6";
export var welcomeContainer = "Welcome_welcomeContainer__8wHQH";